import { v4 as uuidv4 } from "uuid";
import React from "react";
import Select from "react-select";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  UncontrolledCollapse,
  FormGroup,
  Label,
  Input,
  Form,
  CustomInput,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { MdEdit, MdDeleteForever } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import { BsDashCircle } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
import {
  capitalizeFirstLetter,
  smallFirstLetter,
  getAuthUser,
  setAuthUser,
} from "../GeneralFunctions";
let user = {};
let selectedPageIndex;
let removeFieldObject = {};
class RushPlayerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      addPageCollapse: false,
      update: false,
      isOpen: false,
      formKeyName: "",
      selectedPage: 1,
      selectedFieldId: "",
      fieldRequired: true,
      fileType: true,
      cropImage: true,
      selectedType: "text",
      selectedApply: "adult",
      waviersValue: "",
      registerForm: [],
      dropDownValues: [""],
      dropDownValue: "",
      dropDownValueEdit: false,
      selectedValue: "",
      selectedIndexForAdult: null,
      selectedIndexForPlayer: null,
      selectedIndexForStaff: null,
      titleForPlayer: "",
      titleForAdult: "",
      titleForStaff: "",
      previousKeyName: "",
      titleEditForAdult: false,
      titleEditForPlayer: false,
      titleEditForStaff: false,
      previousSelectedPage: 1,
      removePageConfirmationModal: false,
      removeFieldConfirmationModal: false,
      selectedEventForAPI: {},
      selectedCampForAPI: {},
      camps: [],
      childCamps: [],
      childCamp: {},
      showCamps: false,
    };
  }

  componentDidMount() {
    user = getAuthUser();
    user.connectedUser.SPIEvent ? this.getEvents() : this.getDashboardDetails();
  }

  getDashboardDetails = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/dashboard",
        method: "POST",
      });
      if (response) {
        this.setState({
          showLoader: false,
          registerForm: response.details.registerForm,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getEvents = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/rushNational/camps",
        method: "GET",
      });
      if (response) {
        this.setState({
          showCamps: true,
          showLoader: false,
          camps: response.camps,
          selectedEventForAPI: {
            value: response.camps[0]._id,
            label: response.camps[0].name,
          },
          childCamps: response.camps[0].camps,
          childCamp: response.camps[0].camps.length
            ? response.camps[0].camps[0]
            : {},
          selectedCampForAPI: {
            value: response.camps[0].camps.length
              ? response.camps[0].camps[0]._id
              : "",
            label: response.camps[0].camps.length
              ? response.camps[0].camps[0].name
              : "",
          },
          registerForm: response.camps[0].camps.length
            ? response.camps[0].camps[0].registerForm
            : [],
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateForm = async () => {
    try {
      this.setState({ showLoader: true });
      let data = {
        connectedUserId: user.connectedUser._id,
        registerForm: this.state.registerForm,
      };
      if (user.connectedUser.SPIEvent) {
        if (!this.state.selectedCampForAPI.value) throw Error("No camp found");
        Object.assign(data, {
          parentEventId: this.state.selectedEventForAPI.value,
          campId: this.state.selectedCampForAPI.value,
        });
      }
      let response = await Server.request({
        url: "rushsoccer/registerForm/update",
        method: "POST",
        data,
      });
      if (response) {
        if (!user.connectedUser.SPIEvent) {
          user.connectedUser.registerForm = response.registerForm;
          setAuthUser(user);
        }
        this.setState({
          showLoader: false,
          registerForm: response.registerForm,
        });
      }
    } catch (error) {
      error.message === "No camp found"
        ? this.setState({ showLoader: false, registerForm: [] })
        : this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addPage = async (event, obj) => {
    event.preventDefault();
    if (
      this.state.titleEditForAdult ||
      this.state.titleEditForPlayer ||
      this.state.titleEditForStaff
    ) {
      this.state.registerForm.map((form) => {
        if (form.page === this.state.selectedPage) {
          switch (obj.forAdult) {
            case "adult":
              form.title[0].value = this.state.titleForAdult;
              break;
            case "player":
              form.title[1].value = this.state.titleForPlayer;
              break;
            case "staff":
              form.title[2].value = this.state.titleForStaff;
              break;
            default:
              break;
          }
        }
        return form;
      });
    } else {
      this.state.registerForm.push({
        page: this.state.registerForm.length + 1,
        name: `step ${this.state.registerForm.length + 1}`,
        title: [
          {
            for: {
              keyName: "memberType",
              value: "adult",
            },
            value: this.state.titleForAdult,
          },
          {
            for: {
              keyName: "memberType",
              value: "player",
            },
            value: this.state.titleForPlayer,
          },
          {
            for: {
              keyName: "memberType",
              value: "staff",
            },
            value: this.state.titleForStaff,
          },
        ],
        fields: [],
      });
    }
    this.setState({
      addPageCollapse: false,
      titleEditForAdult: false,
      titleEditForPlayer: false,
      titleEditForStaff: false,
      titleForAdult: "",
      titleForPlayer: "",
      titleForStaff: "",
    });
    this.updateForm();
  };

  onSubmit = async (event) => {
    event.preventDefault();
    if (this.state.update) {
      if (this.state.previousSelectedPage !== this.state.selectedPage) {
        this.state.registerForm.map((form) => {
          if (form.page === this.state.previousSelectedPage) {
            let index = form.fields.findIndex(
              (field) => field._id === this.state.selectedFieldId
            );
            form.fields.splice(index, 1);
          }
          if (form.page === this.state.selectedPage) {
            let obj = {
              _id: uuidv4(),
              placeholder: this.state.formKeyName,
              keyName: this.state.previousKeyName,
              name: this.state.formKeyName,
              inputType: this.state.selectedType,
              required: this.state.fieldRequired,
              default: false,
              for: {
                keyName: "memberType",
                value: this.state.selectedApply,
              },
            };
            if (this.state.selectedType === "waviers")
              Object.assign(obj, {
                value: this.state.waviersValue,
              });
            if (this.state.selectedType === "dropdown")
              Object.assign(obj, {
                values:
                  this.state.dropDownValues[0] === ""
                    ? [this.state.dropDownValue]
                    : this.state.dropDownValues,
              });
            if (this.state.selectedType === "fileupload")
              Object.assign(obj, {
                type: this.state.fileType ? "image" : "file",
                cropImage: this.state.cropImage,
              });
            form.fields.push(obj);
          }
          this.setState({
            isOpen: false,
            formKeyName: "",
            selectedPage: 1,
            selectedType: "text",
            selectedApply: "adult",
            dropDownValue: "",
            dropDownValues: [""],
          });
          return form;
        });
      } else {
        this.state.registerForm.map((form) => {
          if (form.page === this.state.selectedPage) {
            form.fields = form.fields.map((field) => {
              if (field._id === this.state.selectedFieldId) {
                field.placeholder = this.state.formKeyName;
                field.keyName = this.state.previousKeyName;
                field.name = this.state.formKeyName;
                field.inputType = this.state.selectedType;
                field.required = this.state.fieldRequired;
                field.default = false;
                field.for = {
                  keyName: "memberType",
                  value: this.state.selectedApply,
                };
                if (field.inputType === "waviers")
                  Object.assign(field, {
                    value: this.state.waviersValue,
                  });
                if (field.inputType === "dropdown")
                  Object.assign(field, {
                    values:
                      this.state.dropDownValues[0] === ""
                        ? [this.state.dropDownValue]
                        : this.state.dropDownValues,
                  });
                if (field.inputType === "fileupload")
                  Object.assign(field, {
                    type: this.state.fileType ? "image" : "file",
                    cropImage: this.state.cropImage,
                  });
                if (field.inputType !== "dropdown") delete field.values;
                if (field.inputType !== "fileupload") {
                  delete field.type;
                  delete field.cropImage;
                }
                this.setState({
                  isOpen: false,
                  formKeyName: "",
                  selectedPage: 1,
                  selectedType: "text",
                  selectedApply: "adult",
                  dropDownValue: "",
                  dropDownValues: [""],
                });
              }
              return field;
            });
          }
          return form;
        });
      }
    } else {
      this.state.registerForm.map((form) => {
        if (form.page === this.state.selectedPage) {
          let formFields = form.fields.filter(
            (field) => field.name === this.state.formKeyName
          );
          let keyName = formFields.length
            ? `${smallFirstLetter(this.state.formKeyName)
                .replace(/\s/g, "")
                .replace(/\W|_/g, "")}${formFields.length}`
            : smallFirstLetter(this.state.formKeyName)
                .replace(/\s/g, "")
                .replace(/\W|_/g, "");
          let obj = {
            _id: uuidv4(),
            placeholder: this.state.formKeyName,
            keyName,
            name: this.state.formKeyName,
            inputType: this.state.selectedType,
            required: this.state.fieldRequired,
            default: false,
            for: {
              keyName: "memberType",
              value: this.state.selectedApply,
            },
          };
          if (this.state.selectedType === "waviers")
            Object.assign(obj, {
              value: this.state.waviersValue,
            });
          if (this.state.selectedType === "dropdown")
            Object.assign(obj, {
              values:
                this.state.dropDownValues[0] === ""
                  ? this.state.dropDownValue.split(",")
                  : this.state.dropDownValues,
            });
          if (this.state.selectedType === "fileupload")
            Object.assign(obj, {
              type: this.state.fileType ? "image" : "file",
              cropImage: this.state.cropImage,
            });
          form.fields.push(obj);
          this.setState({
            isOpen: false,
            formKeyName: "",
            selectedPage: 1,
            selectedType: "text",
            selectedApply: "adult",
            dropDownValue: "",
            dropDownValues: [""],
          });
        }
        return form;
      });
    }
    this.updateForm();
  };

  deleteField = async (obj) => {
    this.state.registerForm.map((form) => {
      if (form.page === obj.selectedPage) {
        let index = form.fields.findIndex(
          (field) => field._id === obj.selectedFieldId
        );
        form.fields.splice(index, 1);
        this.setState({
          isOpen: false,
          formKeyName: "",
          selectedPage: 1,
          selectedType: "text",
          selectedApply: "adult",
          dropDownValue: "",
          dropDownValues: [""],
        });
      }
      return form;
    });
    this.updateForm();
  };

  deleteFieldValues = async (obj) => {
    if (obj.cancelField) {
      if (!this.state.dropDownValueEdit) {
        this.state.registerForm.map((form) => {
          if (form.page === obj.page) {
            form.fields = form.fields.map((field) => {
              if (field._id === obj.fieldId && field.values) {
                field.values.splice(obj.valueIndex, 1);
              }
              return field;
            });
          }
          return form;
        });
      }
      this.setState({
        selectedValue: "",
        selectedFieldId: "",
        selectedIndexForAdult: null,
        selectedIndexForPlayer: null,
        selectedIndexForStaff: null,
      });
    } else {
      this.setState({
        selectedFieldId: "",
      });
      this.state.registerForm.map((form) => {
        if (form.page === obj.page) {
          form.fields = form.fields.map((field) => {
            if (field._id === obj.fieldId && field.values) {
              field.values.splice(obj.valueIndex, 1);
            }
            return field;
          });
        }
        return form;
      });
      this.updateForm();
    }
  };

  addField = async (obj) => {
    this.state.registerForm.map((form) => {
      if (form.page === obj.page) {
        form.fields = form.fields.map((field) => {
          if (field._id === obj.fieldId && field.values) {
            let length = field.values.length;
            field.values.push("");
            switch (obj.for) {
              case "adult":
                this.setState({
                  dropDownValueEdit: false,
                  selectedFieldId: obj.fieldId,
                  selectedIndexForAdult: length,
                });
                break;
              case "player":
                this.setState({
                  dropDownValueEdit: false,
                  selectedFieldId: obj.fieldId,
                  selectedIndexForPlayer: length,
                });
                break;
              case "staff":
                this.setState({
                  dropDownValueEdit: false,
                  selectedFieldId: obj.fieldId,
                  selectedIndexForStaff: length,
                });
                break;
              default:
                break;
            }
          }
          return field;
        });
      }
      return form;
    });
  };

  updateValues = async (obj) => {
    if (!this.state.selectedValue) {
      this.notificationSystem.addNotification({
        message: "Add some value",
        level: "error",
      });
      return;
    }
    let values = this.state.selectedValue.split(",");
    if (values.length > 1) {
      this.state.registerForm.map((form) => {
        if (form.page === obj.page) {
          form.fields = form.fields.map((field) => {
            if (field._id === obj.fieldId && field.values) {
              for (let index = 0; index < values.length; index++) {
                const value = values[index];
                if (index === 0) {
                  field.values[obj.valueIndex] = value;
                } else {
                  field.values.push(value);
                }
              }
            }
            return field;
          });
        }
        return form;
      });
    } else {
      this.state.registerForm.map((form) => {
        if (form.page === obj.page) {
          form.fields = form.fields.map((field) => {
            if (field._id === obj.fieldId && field.values) {
              field.values[obj.valueIndex] = this.state.selectedValue;
            }
            return field;
          });
        }
        return form;
      });
    }
    this.setState({
      selectedValue: "",
      selectedFieldId: "",
      selectedIndexForAdult: null,
      selectedIndexForPlayer: null,
      selectedIndexForStaff: null,
    });
    this.updateForm();
  };

  toggleRemovePageConfirmationModal = (index) => {
    if (!selectedPageIndex && index) {
      selectedPageIndex = index;
    }
    this.setState({
      removePageConfirmationModal: !this.state.removePageConfirmationModal,
    });
  };

  toggleRemoveFieldConfirmationModal = (obj) => {
    if (!removeFieldObject.selectedFieldId && obj) {
      removeFieldObject = obj;
    }
    this.setState({
      removeFieldConfirmationModal: !this.state.removeFieldConfirmationModal,
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Registration Form"
          breadcrumbs={[{ name: "Registration Form", active: true }]}
        >
          <Row>
            <Col>
              {this.state.showCamps && (
                <Card className="mb-3">
                  <CardBody>
                    <Row>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <FormGroup>
                          <Label for="name">Select SPI Event :</Label>
                          <Select
                            value={this.state.selectedEventForAPI}
                            options={[
                              ...this.state.camps.map((camp) => ({
                                value: camp._id,
                                label: camp.name,
                              })),
                            ]}
                            onChange={(result) => {
                              let camp = this.state.camps.find(
                                (camp) => camp._id === result.value
                              );
                              // let registerForm = camp ? camp.registerForm : [];
                              this.setState({
                                selectedEventForAPI: result,
                                // registerForm,
                                childCamps: camp.camps,
                                selectedCampForAPI: {
                                  label: camp.camps.length
                                    ? camp.camps[0].name
                                    : "",
                                  value: camp.camps.length
                                    ? camp.camps[0]._id
                                    : "",
                                },
                                registerForm: camp.camps.length
                                  ? camp.camps[0].registerForm
                                  : [],
                              });
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <FormGroup>
                          <Label for="name">Select Event :</Label>
                          <Select
                            value={this.state.selectedCampForAPI}
                            options={[
                              ...this.state.childCamps.map((camp) => ({
                                value: camp._id,
                                label: camp.name,
                              })),
                            ]}
                            onChange={(result) => {
                              let camp = this.state.childCamps.find(
                                (camp) => camp._id === result.value
                              );
                              let registerForm = camp ? camp.registerForm : [];
                              this.setState({
                                childCamp: camp,
                                selectedCampForAPI: result,
                                registerForm,
                              });
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}
              <Card className="mb-3">
                <CardHeader>
                  <Button
                    onClick={() =>
                      this.setState({
                        update: false,
                        isOpen: true,
                        addPageCollapse: false,
                        fieldRequired: true,
                        fileType: true,
                        cropImage: true,
                        formKeyName: "",
                        selectedPage: 1,
                        selectedType: "text",
                        selectedApply: "adult",
                        waviersValue: "",
                      })
                    }
                    color="primary"
                    id="toggler"
                    style={{ marginBottom: "1rem" }}
                  >
                    Add a form field
                  </Button>
                  <Button
                    color="primary"
                    id="toggler1"
                    style={{ float: "right", marginBottom: "1rem" }}
                    onClick={() => {
                      this.setState({
                        isOpen: false,
                        addPageCollapse: !this.state.addPageCollapse,
                      });
                    }}
                  >
                    Add Page
                  </Button>
                  <Modal
                    isOpen={this.state.isOpen}
                    toggle={(event) => {
                      this.setState({
                        isOpen: false,
                      });
                    }}
                    className="modal-md"
                  >
                    <Form className="form" onSubmit={this.onSubmit}>
                      <ModalHeader
                        toggle={(event) => {
                          this.setState({
                            isOpen: false,
                          });
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "30px",
                          }}
                        >
                          {this.state.update
                            ? "Update Form Field"
                            : "Add Form Field"}
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label for="name">Name</Label>
                                  <Input
                                    required
                                    type="text"
                                    name="name"
                                    value={this.state.formKeyName}
                                    placeholder="Name"
                                    autoComplete="off"
                                    onChange={(event) =>
                                      this.setState({
                                        formKeyName: event.target.value,
                                      })
                                    }
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label for="type">Type</Label>
                                  <Input
                                    required
                                    type="select"
                                    value={this.state.selectedType}
                                    name="type"
                                    onChange={(event) => {
                                      this.setState({
                                        selectedType: event.target.value,
                                      });
                                    }}
                                  >
                                    <option value={"text"}>
                                      Single Text Field
                                    </option>
                                    <option value={"number"}>Numeric</option>
                                    <option value={"datepicker"}>
                                      Date Picker
                                    </option>
                                    <option value={"dropdown"}>
                                      Dropdown List
                                    </option>
                                    <option value={"fileupload"}>
                                      File Upload
                                    </option>
                                    <option value={"waviers"}>Waviers</option>
                                  </Input>
                                </FormGroup>
                              </Col>
                            </Row>
                            {this.state.selectedType === "waviers" && (
                              <Row>
                                <Col xl={12} lg={12} md={12}>
                                  <FormGroup>
                                    <Label for="value">Value</Label>
                                    <Input
                                      required
                                      type="textarea"
                                      name="value"
                                      value={this.state.waviersValue}
                                      placeholder="Enter the value"
                                      autoComplete="off"
                                      style={{
                                        height: "150px",
                                      }}
                                      onChange={(event) =>
                                        this.setState({
                                          waviersValue: event.target.value,
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            )}
                            {this.state.selectedType === "dropdown" && (
                              <Row>
                                <Col xl={12} lg={12} md={12}>
                                  <FormGroup>
                                    <Label for="name">
                                      Dropdown List Value(Example Item 1, Item
                                      2, Item 3)
                                    </Label>
                                    {this.state.update &&
                                    this.state.dropDownValues[0] !== ""
                                      ? this.state.dropDownValues.map(
                                          (value, index) => (
                                            <Input
                                              className="mb-2"
                                              key={index}
                                              disabled={true}
                                              type="text"
                                              value={value}
                                            />
                                          )
                                        )
                                      : this.state.dropDownValues.map(
                                          (value, index) => (
                                            <Input
                                              key={index}
                                              required
                                              type="text"
                                              name="dropDownValue"
                                              value={this.state.dropDownValue}
                                              placeholder="Value"
                                              autoComplete="off"
                                              onChange={(event) => {
                                                this.setState({
                                                  dropDownValue:
                                                    event.target.value,
                                                });
                                              }}
                                            />
                                          )
                                        )}
                                  </FormGroup>
                                </Col>
                              </Row>
                            )}
                            {this.state.selectedType === "fileupload" && (
                              <>
                                <Row>
                                  <Col xl={12} lg={12} md={12}>
                                    <FormGroup>
                                      <Label for="required">File Type</Label>
                                      <div style={{ display: "flex" }}>
                                        <CustomInput
                                          id="image"
                                          type="radio"
                                          label="Image"
                                          name="fileType"
                                          checked={this.state.fileType}
                                          onClick={(event) => {
                                            this.setState({
                                              fileType: true,
                                            });
                                          }}
                                        />
                                        <CustomInput
                                          id="file"
                                          type="radio"
                                          label="File"
                                          name="fileType"
                                          checked={!this.state.fileType}
                                          onClick={(event) => {
                                            this.setState({
                                              fileType: false,
                                            });
                                          }}
                                        />
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={12} lg={12} md={12}>
                                    <FormGroup>
                                      <Label for="required">Crop Image</Label>
                                      <div style={{ display: "flex" }}>
                                        <CustomInput
                                          id="cropImageTrue"
                                          type="radio"
                                          label="True"
                                          name="cropImage"
                                          checked={this.state.cropImage}
                                          onClick={(event) => {
                                            this.setState({
                                              cropImage: true,
                                            });
                                          }}
                                        />
                                        <CustomInput
                                          id="cropImageFalse"
                                          type="radio"
                                          label="False"
                                          name="cropImage"
                                          checked={!this.state.cropImage}
                                          onClick={(event) => {
                                            this.setState({
                                              cropImage: false,
                                            });
                                          }}
                                        />
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </>
                            )}
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label for="page">Select Page</Label>
                                  <Input
                                    required
                                    type="select"
                                    value={this.state.selectedPage}
                                    name="page"
                                    onChange={(event) => {
                                      this.setState({
                                        selectedPage: Number(
                                          event.target.value
                                        ),
                                      });
                                    }}
                                  >
                                    {this.state.registerForm.length &&
                                      this.state.registerForm.map(
                                        (form, index) => (
                                          <option value={form.page} key={index}>
                                            Page {form.page}
                                          </option>
                                        )
                                      )}
                                  </Input>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label for="apply">Apply</Label>
                                  <Input
                                    required
                                    type="select"
                                    value={this.state.selectedApply}
                                    name="apply"
                                    onChange={(event) => {
                                      this.setState({
                                        selectedApply: event.target.value,
                                      });
                                    }}
                                  >
                                    {this.state.childCamp.teamRegistration ? (
                                      <>
                                        <option value={"adult"}>
                                          Only For Team
                                        </option>
                                      </>
                                    ) : (
                                      <>
                                        <option value={"adult"}>
                                          Only For Adults
                                        </option>
                                        <option value={"player"}>
                                          Only For Players
                                        </option>
                                        <option value={"staff"}>
                                          Only For Staff
                                        </option>
                                      </>
                                    )}
                                  </Input>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label for="required">Field Required</Label>
                                  <div style={{ display: "flex" }}>
                                    <CustomInput
                                      id="fieldRequired"
                                      type="radio"
                                      label="True"
                                      name="fieldRequired"
                                      checked={this.state.fieldRequired}
                                      onClick={(event) => {
                                        this.setState({
                                          fieldRequired: true,
                                        });
                                      }}
                                    />
                                    <CustomInput
                                      id="fieldRequired1"
                                      type="radio"
                                      label="False"
                                      name="fieldRequired"
                                      checked={!this.state.fieldRequired}
                                      onClick={(event) => {
                                        this.setState({
                                          fieldRequired: false,
                                        });
                                      }}
                                    />
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </ModalBody>
                      <ModalFooter>
                        <Button type="submit" color="primary">
                          Submit
                        </Button>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.setState({
                              isOpen: false,
                            });
                          }}
                        >
                          Cancel
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <UncontrolledCollapse
                    toggler="#toggler1"
                    isOpen={this.state.addPageCollapse}
                  >
                    <Card>
                      <CardBody>
                        <Form className="form" onSubmit={this.addPage}>
                          <Row>
                            <Col xl={6} lg={12} md={12}>
                              <FormGroup>
                                <Label for="name">Page Title For Adults </Label>
                                <Input
                                  required
                                  type="text"
                                  name="titleForAdult"
                                  value={this.state.titleForAdult}
                                  placeholder="Page Title For Adult"
                                  autoComplete="off"
                                  onChange={(event) =>
                                    this.setState({
                                      titleForAdult: event.target.value,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={12} md={12}>
                              <FormGroup>
                                <Label for="name">
                                  Page Title For Players{" "}
                                </Label>
                                <Input
                                  required
                                  type="text"
                                  name="titleForPlayer"
                                  value={this.state.titleForPlayer}
                                  placeholder="Page Title For Player"
                                  autoComplete="off"
                                  onChange={(event) =>
                                    this.setState({
                                      titleForPlayer: event.target.value,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={12} md={12}>
                              <FormGroup>
                                <Label for="name">Page Title For Staff </Label>
                                <Input
                                  required
                                  type="text"
                                  name="titleForStaff"
                                  value={this.state.titleForStaff}
                                  placeholder="Page Title For Staff"
                                  autoComplete="off"
                                  onChange={(event) =>
                                    this.setState({
                                      titleForStaff: event.target.value,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={12} md={12}>
                              <FormGroup>
                                <Button outline color="primary" type="submit">
                                  Submit
                                </Button>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </CardHeader>
              </Card>
              <Card className="mb-3">
                <CardBody>
                  {this.state.registerForm.length ? (
                    <Tabs style={{ width: "100%" }}>
                      <TabList>
                        {this.state.registerForm.map((form, index) => (
                          <Tab key={index}>Page {form.page}</Tab>
                        ))}
                      </TabList>
                      {this.state.registerForm.map((form, index) => (
                        <TabPanel>
                          <Row>
                            <Col sm={12} md={12} lg={6} xl={6}>
                              <div className="d-flex justify-content-end">
                                <h2>Page {form.page}</h2>
                              </div>
                            </Col>
                            {form.page > 2 && (
                              <Col sm={12} md={12} lg={6} xl={6}>
                                <div className="d-flex justify-content-end">
                                  <Button
                                    className="mt-2 mr-2 mb-2 mb-md-0"
                                    onClick={(event) => {
                                      this.toggleRemovePageConfirmationModal(
                                        index
                                      );
                                    }}
                                  >
                                    Delete Page
                                  </Button>
                                </div>
                              </Col>
                            )}
                          </Row>
                          {this.state.childCamp.teamRegistration ? (
                            <h2>For Team :</h2>
                          ) : (
                            <h2>For Adults :</h2>
                          )}
                          {form.title &&
                            form.title
                              .filter((title) => title.for.value === "adult")
                              .map((title, index) => (
                                <FormGroup key={index}>
                                  <h4>Title</h4>
                                  {this.state.titleEditForAdult ? (
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        value={this.state.titleForAdult}
                                        name="titleForAdult"
                                        style={{
                                          marginRight: "45px",
                                        }}
                                        onChange={(event) => {
                                          this.setState({
                                            titleForAdult: event.target.value,
                                          });
                                        }}
                                      ></Input>
                                      <Button
                                        onClick={(event) => {
                                          this.addPage(event, {
                                            forAdult: "adult",
                                          });
                                        }}
                                      >
                                        <FaCheck size="20px"></FaCheck>
                                      </Button>
                                    </div>
                                  ) : (
                                    <div className="d-flex">
                                      <Input
                                        disabled
                                        type="text"
                                        value={title.value}
                                        name="title"
                                        style={{
                                          marginRight: "45px",
                                        }}
                                      ></Input>
                                      <Button
                                        onClick={() => {
                                          this.setState({
                                            isOpen: false,
                                            addPageCollapse: false,
                                            titleEditForAdult: true,
                                            titleForAdult: title.value,
                                            selectedPage: Number(form.page),
                                          });
                                        }}
                                      >
                                        <MdEdit size="20px"></MdEdit>
                                      </Button>
                                    </div>
                                  )}
                                </FormGroup>
                              ))}
                          <Row className="mb-2">
                            <Col sm={12} md={12} lg={12}>
                              <Table striped hover responsive>
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Input Type</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {form.fields &&
                                    form.fields
                                      .filter(
                                        (field) => field.for.value === "adult"
                                      )
                                      .map((field, index) => (
                                        <tr key={index}>
                                          <td>
                                            {field.placeholder}
                                            {field.inputType === "dropdown" && (
                                              <>
                                                <FiPlusCircle
                                                  size="25px"
                                                  style={{
                                                    float: "right",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.addField({
                                                      for: "adult",
                                                      page: form.page,
                                                      fieldId: field._id,
                                                    })
                                                  }
                                                ></FiPlusCircle>
                                                {field.values.map(
                                                  (value, index) => (
                                                    <div key={index}>
                                                      <div className="d-flex mt-1">
                                                        {this.state
                                                          .selectedIndexForAdult ===
                                                          index &&
                                                        this.state
                                                          .selectedFieldId ===
                                                          field._id ? (
                                                          <Input
                                                            disabled={false}
                                                            type="text"
                                                            value={
                                                              this.state
                                                                .selectedValue
                                                            }
                                                            name="dropdownValue"
                                                            className="mt-3"
                                                            onChange={(
                                                              event
                                                            ) => {
                                                              this.setState({
                                                                selectedValue:
                                                                  event.target
                                                                    .value,
                                                              });
                                                            }}
                                                          />
                                                        ) : (
                                                          <Input
                                                            disabled
                                                            type="text"
                                                            value={value}
                                                            name="dropdownValue"
                                                            className="mt-3"
                                                          />
                                                        )}
                                                        <MdEdit
                                                          size="25px"
                                                          onClick={() => {
                                                            this.setState({
                                                              dropDownValueEdit: true,
                                                              selectedValue: value,
                                                              selectedFieldId:
                                                                field._id,
                                                              selectedIndexForStaff: null,
                                                              selectedIndexForPlayer: null,
                                                              selectedIndexForAdult: index,
                                                            });
                                                          }}
                                                          style={{
                                                            cursor: "pointer",
                                                            float: "right",
                                                            margin: "0 4px",
                                                            marginTop: "20px",
                                                          }}
                                                        ></MdEdit>
                                                        <BsDashCircle
                                                          size="25px"
                                                          style={{
                                                            cursor: "pointer",
                                                            float: "right",
                                                            margin: "0 auto",
                                                            marginTop: "20px",
                                                          }}
                                                          onClick={() =>
                                                            this.deleteFieldValues(
                                                              {
                                                                cancelField: false,
                                                                page: form.page,
                                                                valueIndex: index,
                                                                fieldId:
                                                                  field._id,
                                                              }
                                                            )
                                                          }
                                                        ></BsDashCircle>
                                                      </div>
                                                      {this.state
                                                        .selectedIndexForAdult ===
                                                        index &&
                                                        this.state
                                                          .selectedFieldId ===
                                                          field._id && (
                                                          <div>
                                                            <Button
                                                              className="mt-2 mr-2"
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                this.updateValues(
                                                                  {
                                                                    page:
                                                                      form.page,
                                                                    valueIndex: index,
                                                                    fieldId:
                                                                      field._id,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              Save
                                                            </Button>
                                                            <Button
                                                              className="mt-2 mr-2"
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                this.deleteFieldValues(
                                                                  {
                                                                    cancelField: true,
                                                                    page:
                                                                      form.page,
                                                                    valueIndex: index,
                                                                    fieldId:
                                                                      field._id,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              Cancel
                                                            </Button>
                                                          </div>
                                                        )}
                                                    </div>
                                                  )
                                                )}
                                              </>
                                            )}
                                          </td>
                                          <td>
                                            {capitalizeFirstLetter(
                                              field.inputType
                                            )}
                                          </td>
                                          <td>
                                            {!field.default && (
                                              <>
                                                <Button
                                                  className={
                                                    "mr-4 mb-2 mb-md-0"
                                                  }
                                                  id="toggler"
                                                  onClick={() => {
                                                    this.setState({
                                                      isOpen: false,
                                                      update: true,
                                                      formKeyName:
                                                        field.placeholder,
                                                      selectedFieldId:
                                                        field._id,
                                                      selectedPage: Number(
                                                        form.page
                                                      ),
                                                      previousSelectedPage: Number(
                                                        form.page
                                                      ),
                                                      selectedType:
                                                        field.inputType,
                                                      selectedApply: "adult",
                                                      fieldRequired:
                                                        field.required,
                                                      dropDownValues: field.values
                                                        ? field.values
                                                        : [""],
                                                      fileType: field.type
                                                        ? field.type === "image"
                                                          ? true
                                                          : false
                                                        : true,
                                                      cropImage: field.hasOwnProperty(
                                                        "cropImage"
                                                      )
                                                        ? field.cropImage
                                                        : true,
                                                      previousKeyName:
                                                        field.keyName,
                                                      waviersValue: field.value
                                                        ? field.value
                                                        : "",
                                                    });
                                                    this.setState({
                                                      isOpen: true,
                                                    });
                                                  }}
                                                >
                                                  <MdEdit size="20px"></MdEdit>
                                                </Button>
                                                <Button
                                                  onClick={(event) => {
                                                    this.toggleRemoveFieldConfirmationModal(
                                                      {
                                                        selectedFieldId:
                                                          field._id,
                                                        selectedPage: Number(
                                                          form.page
                                                        ),
                                                      }
                                                    );
                                                  }}
                                                >
                                                  <MdDeleteForever size="20px"></MdDeleteForever>
                                                </Button>
                                              </>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                          {this.state.childCamp.teamRegistration ? null : (
                            <>
                              <h2>For Players :</h2>
                              {form.title &&
                                form.title
                                  .filter(
                                    (title) => title.for.value === "player"
                                  )
                                  .map((title, index) => (
                                    <FormGroup key={index}>
                                      <h4>Title</h4>
                                      {this.state.titleEditForPlayer ? (
                                        <div className="d-flex">
                                          <Input
                                            type="text"
                                            value={this.state.titleForPlayer}
                                            name="titleForAdult"
                                            style={{
                                              marginRight: "45px",
                                            }}
                                            onChange={(event) => {
                                              this.setState({
                                                titleForPlayer:
                                                  event.target.value,
                                              });
                                            }}
                                          ></Input>
                                          <Button
                                            onClick={(event) => {
                                              this.addPage(event, {
                                                forAdult: "player",
                                              });
                                            }}
                                          >
                                            <FaCheck size="20px"></FaCheck>
                                          </Button>
                                        </div>
                                      ) : (
                                        <div className="d-flex">
                                          <Input
                                            disabled
                                            type="text"
                                            value={title.value}
                                            name="title"
                                            style={{
                                              marginRight: "45px",
                                            }}
                                          ></Input>
                                          <Button
                                            onClick={() => {
                                              this.setState({
                                                isOpen: false,
                                                addPageCollapse: false,
                                                titleEditForPlayer: true,
                                                titleForPlayer: title.value,
                                                selectedPage: Number(form.page),
                                              });
                                            }}
                                          >
                                            <MdEdit size="20px"></MdEdit>
                                          </Button>
                                        </div>
                                      )}
                                    </FormGroup>
                                  ))}
                              <Row className="mb-2">
                                <Col sm={12} md={12} lg={12}>
                                  <Table striped hover responsive>
                                    <thead>
                                      <tr>
                                        <th>Name</th>
                                        <th>Input Type</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {form.fields &&
                                        form.fields
                                          .filter(
                                            (field) =>
                                              field.for.value === "player"
                                          )
                                          .map((field, index) => (
                                            <tr key={index}>
                                              <td>
                                                {field.placeholder}
                                                {field.inputType ===
                                                  "dropdown" &&
                                                  field.keyName !==
                                                    "parentId" && (
                                                    <>
                                                      <FiPlusCircle
                                                        size="25px"
                                                        style={{
                                                          float: "right",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          this.addField({
                                                            for: "player",
                                                            page: form.page,
                                                            fieldId: field._id,
                                                          })
                                                        }
                                                      ></FiPlusCircle>
                                                      {field.values.map(
                                                        (value, index) => (
                                                          <div key={index}>
                                                            <div className="d-flex mt-1">
                                                              {this.state
                                                                .selectedIndexForPlayer ===
                                                                index &&
                                                              this.state
                                                                .selectedFieldId ===
                                                                field._id ? (
                                                                <Input
                                                                  disabled={
                                                                    false
                                                                  }
                                                                  type="text"
                                                                  value={
                                                                    this.state
                                                                      .selectedValue
                                                                  }
                                                                  name="dropdownValue"
                                                                  className="mt-3"
                                                                  onChange={(
                                                                    event
                                                                  ) => {
                                                                    this.setState(
                                                                      {
                                                                        selectedValue:
                                                                          event
                                                                            .target
                                                                            .value,
                                                                      }
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                <Input
                                                                  disabled
                                                                  type="text"
                                                                  value={value}
                                                                  name="dropdownValue"
                                                                  className="mt-3"
                                                                />
                                                              )}
                                                              <MdEdit
                                                                size="25px"
                                                                onClick={() => {
                                                                  this.setState(
                                                                    {
                                                                      dropDownValueEdit: true,
                                                                      selectedFieldId:
                                                                        field._id,
                                                                      selectedValue: value,
                                                                      selectedIndexForStaff: null,
                                                                      selectedIndexForAdult: null,
                                                                      selectedIndexForPlayer: index,
                                                                    }
                                                                  );
                                                                }}
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  float:
                                                                    "right",
                                                                  margin:
                                                                    "0 4px",
                                                                  marginTop:
                                                                    "20px",
                                                                }}
                                                              ></MdEdit>
                                                              <BsDashCircle
                                                                size="25px"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  float:
                                                                    "right",
                                                                  margin:
                                                                    "0 auto",
                                                                  marginTop:
                                                                    "20px",
                                                                }}
                                                                onClick={() =>
                                                                  this.deleteFieldValues(
                                                                    {
                                                                      cancelField: false,
                                                                      page:
                                                                        form.page,
                                                                      valueIndex: index,
                                                                      fieldId:
                                                                        field._id,
                                                                    }
                                                                  )
                                                                }
                                                              ></BsDashCircle>
                                                            </div>
                                                            {this.state
                                                              .selectedIndexForPlayer ===
                                                              index &&
                                                              this.state
                                                                .selectedFieldId ===
                                                                field._id && (
                                                                <div>
                                                                  <Button
                                                                    className="mt-2 mr-2"
                                                                    onClick={(
                                                                      event
                                                                    ) =>
                                                                      this.updateValues(
                                                                        {
                                                                          page:
                                                                            form.page,
                                                                          valueIndex: index,
                                                                          fieldId:
                                                                            field._id,
                                                                        }
                                                                      )
                                                                    }
                                                                  >
                                                                    Save
                                                                  </Button>
                                                                  <Button
                                                                    className="mt-2 mr-2"
                                                                    onClick={(
                                                                      event
                                                                    ) =>
                                                                      this.deleteFieldValues(
                                                                        {
                                                                          cancelField: true,
                                                                          page:
                                                                            form.page,
                                                                          valueIndex: index,
                                                                          fieldId:
                                                                            field._id,
                                                                        }
                                                                      )
                                                                    }
                                                                  >
                                                                    Cancel
                                                                  </Button>
                                                                </div>
                                                              )}
                                                          </div>
                                                        )
                                                      )}
                                                    </>
                                                  )}
                                              </td>
                                              <td>
                                                {capitalizeFirstLetter(
                                                  field.inputType
                                                )}
                                              </td>
                                              <td>
                                                {!field.default && (
                                                  <>
                                                    <Button
                                                      className={
                                                        "mr-4 mb-2 mb-md-0"
                                                      }
                                                      id="toggler"
                                                      onClick={() => {
                                                        this.setState({
                                                          isOpen: false,
                                                          update: true,
                                                          formKeyName:
                                                            field.placeholder,
                                                          selectedFieldId:
                                                            field._id,
                                                          selectedPage: Number(
                                                            form.page
                                                          ),
                                                          previousSelectedPage: Number(
                                                            form.page
                                                          ),
                                                          selectedType:
                                                            field.inputType,
                                                          selectedApply:
                                                            "player",
                                                          fieldRequired:
                                                            field.required,
                                                          dropDownValues: field.values
                                                            ? field.values
                                                            : [""],
                                                          fileType: field.type
                                                            ? field.type ===
                                                              "image"
                                                              ? true
                                                              : false
                                                            : true,
                                                          cropImage: field.hasOwnProperty(
                                                            "cropImage"
                                                          )
                                                            ? field.cropImage
                                                            : true,
                                                          previousKeyName:
                                                            field.keyName,
                                                          waviersValue: field.value
                                                            ? field.value
                                                            : "",
                                                        });
                                                        this.setState({
                                                          isOpen: true,
                                                        });
                                                      }}
                                                    >
                                                      <MdEdit size="20px"></MdEdit>
                                                    </Button>
                                                    <Button
                                                      onClick={(event) => {
                                                        this.toggleRemoveFieldConfirmationModal(
                                                          {
                                                            selectedFieldId:
                                                              field._id,
                                                            selectedPage: Number(
                                                              form.page
                                                            ),
                                                          }
                                                        );
                                                      }}
                                                    >
                                                      <MdDeleteForever size="20px"></MdDeleteForever>
                                                    </Button>
                                                  </>
                                                )}
                                              </td>
                                            </tr>
                                          ))}
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row>
                              <h2>For Staff :</h2>
                              {form.title &&
                                form.title
                                  .filter(
                                    (title) => title.for.value === "staff"
                                  )
                                  .map((title, index) => (
                                    <FormGroup key={index}>
                                      <h4>Title</h4>
                                      {this.state.titleEditForStaff ? (
                                        <div className="d-flex">
                                          <Input
                                            type="text"
                                            value={this.state.titleForStaff}
                                            name="titleForAdult"
                                            style={{
                                              marginRight: "45px",
                                            }}
                                            onChange={(event) => {
                                              this.setState({
                                                titleForStaff:
                                                  event.target.value,
                                              });
                                            }}
                                          ></Input>
                                          <Button
                                            onClick={(event) => {
                                              this.addPage(event, {
                                                forAdult: "staff",
                                              });
                                            }}
                                          >
                                            <FaCheck size="20px"></FaCheck>
                                          </Button>
                                        </div>
                                      ) : (
                                        <div className="d-flex">
                                          <Input
                                            disabled
                                            type="text"
                                            value={title.value}
                                            name="title"
                                            style={{
                                              marginRight: "45px",
                                            }}
                                          ></Input>
                                          <Button
                                            onClick={() => {
                                              this.setState({
                                                isOpen: false,
                                                addPageCollapse: false,
                                                titleEditForStaff: true,
                                                titleForStaff: title.value,
                                                selectedPage: Number(form.page),
                                              });
                                            }}
                                          >
                                            <MdEdit size="20px"></MdEdit>
                                          </Button>
                                        </div>
                                      )}
                                    </FormGroup>
                                  ))}
                              <Row className="mb-2">
                                <Col sm={12} md={12} lg={12}>
                                  <Table striped hover responsive>
                                    <thead>
                                      <tr>
                                        <th>Name</th>
                                        <th>Input Type</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {form.fields &&
                                        form.fields
                                          .filter(
                                            (field) =>
                                              field.for.value === "staff"
                                          )
                                          .map((field, index) => (
                                            <tr key={index}>
                                              <td>
                                                {field.placeholder}
                                                {field.inputType ===
                                                  "dropdown" && (
                                                  <>
                                                    <FiPlusCircle
                                                      size="25px"
                                                      style={{
                                                        float: "right",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.addField({
                                                          for: "staff",
                                                          page: form.page,
                                                          fieldId: field._id,
                                                        })
                                                      }
                                                    ></FiPlusCircle>
                                                    {field.values.map(
                                                      (value, index) => (
                                                        <div key={index}>
                                                          <div className="d-flex mt-1">
                                                            {this.state
                                                              .selectedIndexForStaff ===
                                                              index &&
                                                            this.state
                                                              .selectedFieldId ===
                                                              field._id ? (
                                                              <Input
                                                                disabled={false}
                                                                type="text"
                                                                value={
                                                                  this.state
                                                                    .selectedValue
                                                                }
                                                                name="dropdownValue"
                                                                className="mt-3"
                                                                onChange={(
                                                                  event
                                                                ) => {
                                                                  this.setState(
                                                                    {
                                                                      selectedValue:
                                                                        event
                                                                          .target
                                                                          .value,
                                                                    }
                                                                  );
                                                                }}
                                                              />
                                                            ) : (
                                                              <Input
                                                                disabled
                                                                type="text"
                                                                value={value}
                                                                name="dropdownValue"
                                                                className="mt-3"
                                                              />
                                                            )}
                                                            <MdEdit
                                                              size="25px"
                                                              onClick={() => {
                                                                this.setState({
                                                                  dropDownValueEdit: true,
                                                                  selectedFieldId:
                                                                    field._id,
                                                                  selectedValue: value,
                                                                  selectedIndexForStaff: index,
                                                                  selectedIndexForAdult: null,
                                                                  selectedIndexForPlayer: null,
                                                                });
                                                              }}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                float: "right",
                                                                margin: "0 4px",
                                                                marginTop:
                                                                  "20px",
                                                              }}
                                                            ></MdEdit>
                                                            <BsDashCircle
                                                              size="25px"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                float: "right",
                                                                margin:
                                                                  "0 auto",
                                                                marginTop:
                                                                  "20px",
                                                              }}
                                                              onClick={() =>
                                                                this.deleteFieldValues(
                                                                  {
                                                                    cancelField: false,
                                                                    page:
                                                                      form.page,
                                                                    valueIndex: index,
                                                                    fieldId:
                                                                      field._id,
                                                                  }
                                                                )
                                                              }
                                                            ></BsDashCircle>
                                                          </div>
                                                          {this.state
                                                            .selectedIndexForStaff ===
                                                            index &&
                                                            this.state
                                                              .selectedFieldId ===
                                                              field._id && (
                                                              <div>
                                                                <Button
                                                                  className="mt-2 mr-2"
                                                                  onClick={(
                                                                    event
                                                                  ) =>
                                                                    this.updateValues(
                                                                      {
                                                                        page:
                                                                          form.page,
                                                                        valueIndex: index,
                                                                        fieldId:
                                                                          field._id,
                                                                      }
                                                                    )
                                                                  }
                                                                >
                                                                  Save
                                                                </Button>
                                                                <Button
                                                                  className="mt-2 mr-2"
                                                                  onClick={(
                                                                    event
                                                                  ) =>
                                                                    this.deleteFieldValues(
                                                                      {
                                                                        cancelField: true,
                                                                        page:
                                                                          form.page,
                                                                        valueIndex: index,
                                                                        fieldId:
                                                                          field._id,
                                                                      }
                                                                    )
                                                                  }
                                                                >
                                                                  Cancel
                                                                </Button>
                                                              </div>
                                                            )}
                                                        </div>
                                                      )
                                                    )}
                                                  </>
                                                )}
                                              </td>
                                              <td>
                                                {capitalizeFirstLetter(
                                                  field.inputType
                                                )}
                                              </td>
                                              <td>
                                                {!field.default && (
                                                  <>
                                                    <Button
                                                      className={
                                                        "mr-4 mb-2 mb-md-0"
                                                      }
                                                      id="toggler"
                                                      onClick={() => {
                                                        this.setState({
                                                          isOpen: false,
                                                          update: true,
                                                          formKeyName:
                                                            field.placeholder,
                                                          selectedFieldId:
                                                            field._id,
                                                          selectedPage: Number(
                                                            form.page
                                                          ),
                                                          previousSelectedPage: Number(
                                                            form.page
                                                          ),
                                                          selectedType:
                                                            field.inputType,
                                                          selectedApply:
                                                            "staff",
                                                          fieldRequired:
                                                            field.required,
                                                          dropDownValues: field.values
                                                            ? field.values
                                                            : [""],
                                                          fileType: field.type
                                                            ? field.type ===
                                                              "image"
                                                              ? true
                                                              : false
                                                            : true,
                                                          cropImage: field.hasOwnProperty(
                                                            "cropImage"
                                                          )
                                                            ? field.cropImage
                                                            : true,
                                                          previousKeyName:
                                                            field.keyName,
                                                          waviersValue: field.value
                                                            ? field.value
                                                            : "",
                                                        });
                                                        this.setState({
                                                          isOpen: true,
                                                        });
                                                      }}
                                                    >
                                                      <MdEdit size="20px"></MdEdit>
                                                    </Button>
                                                    <Button
                                                      onClick={(event) => {
                                                        this.toggleRemoveFieldConfirmationModal(
                                                          {
                                                            selectedFieldId:
                                                              field._id,
                                                            selectedPage: Number(
                                                              form.page
                                                            ),
                                                          }
                                                        );
                                                      }}
                                                    >
                                                      <MdDeleteForever size="20px"></MdDeleteForever>
                                                    </Button>
                                                  </>
                                                )}
                                              </td>
                                            </tr>
                                          ))}
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row>
                            </>
                          )}
                        </TabPanel>
                      ))}
                    </Tabs>
                  ) : (
                    <div
                      style={{ background: "#e9ecef", padding: "20px" }}
                      className="d-flex justify-content-center"
                    >
                      <h3
                        style={{
                          fontWeight: "bold",
                          margin: "auto",
                        }}
                      >
                        No Fields
                      </h3>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.removePageConfirmationModal ? (
            <Modal
              isOpen={this.state.removePageConfirmationModal}
              toggle={(event) => this.toggleRemovePageConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleRemovePageConfirmationModal()}
              ></ModalHeader>
              <ModalBody>Are you sure you want to delete this page ?</ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleRemovePageConfirmationModal()}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.state.registerForm.splice(selectedPageIndex, 1);
                    this.toggleRemovePageConfirmationModal();
                    this.updateForm();
                  }}
                >
                  Delete
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.removeFieldConfirmationModal ? (
            <Modal
              isOpen={this.state.removeFieldConfirmationModal}
              toggle={(event) => this.toggleRemoveFieldConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleRemoveFieldConfirmationModal()}
              ></ModalHeader>
              <ModalBody>
                Are you sure you want to delete this field ?
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleRemoveFieldConfirmationModal()}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.toggleRemoveFieldConfirmationModal();
                    this.deleteField(removeFieldObject);
                    removeFieldObject = {};
                  }}
                >
                  Delete
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default RushPlayerForm;
